function ReportComponent($http, AppConstants) {
	'ngInject';

	const service = {
		fetchReports,
		getReports,
		getTotalPriceCurrencies,
		getCommissionCurrencies,
		getPaginationInfo,
		getReportsByNumber,
		clearReports
	};

	let reports = [];
	let filteredReports = [];
	let totalPriceCurrencies = [];
	let commissionCurrencies = {};
	const paginationInfo = {};


	return service;

	function fetchReports(id, dates, page = 1, type, review, perPage, paymentSystem) {
		const params = {
			'params': {
				'page': page,
				'per_page': perPage || AppConstants.perPage,
				'from': dates.from,
				'to': dates.to,
				'with': 'seats,user,client,discount',
				'sort': '-id',
				'filter_by': type
			}
		};
		
		if (review) {
			params.params.review = review;
		}
		
		if (id !== 0) {
			params.params.user_id = id;
		}
		
		if ( paymentSystem ) {
			params.params.payment_system = paymentSystem;
		}

		return $http.get(`${ AppConstants.apiUrl }/reports`, params)
			.then(setReports)
			.catch(failedRequest);
	}

	function getReports() {
		return reports;
	}

	function getTotalPriceCurrencies() {
		return totalPriceCurrencies;
	}

	function getCommissionCurrencies() {
		return commissionCurrencies;
	}

	function setReports(data) {
		paginationInfo.page_size = AppConstants.perPage;
		paginationInfo.page = data.data.current_page;
		paginationInfo.total = data.data.total;
		totalPriceCurrencies = data.data.total_price;
		commissionCurrencies = data.data.commission;

		/** Check if user filter reports by date or number.
		 *  Set and return desired results.
		 */
		if ( data.data.total ) {
			reports = data.data.data;

			return reports;
		} else {
			filteredReports = data.data.data;

			return filteredReports;
		}
	}

	function getPaginationInfo() {
		return paginationInfo;
	}

	function getReportsByNumber() {
		return 	filteredReports;
	}

	function clearReports() {
		reports = [];
		return reports;
	}

	function failedRequest(requestError) {
		return requestError;
	}
}
export default ReportComponent;




/** WEBPACK FOOTER **
 ** ./client/components/report/report.service.js
 **/